export type InputChangeDelegate = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;

export function createInputChangeHandler<TModel>(updateModel: React.Dispatch<React.SetStateAction<TModel>>, callback?: (newVersion: TModel) => void) {
    const creator = (name: string, model: TModel) => {
        const handler: InputChangeDelegate = e => {
            const clone = {
                ...model,
                [name]: e.currentTarget.value
            } as TModel;
            updateModel(clone);
            if (callback) callback(clone)
        }
        return handler;
    };
    return creator;
}